module.exports = __webpack_public_path__ + "static/media/free_tag.43997333.svg";